/**
 * カレンダーの色(Google の #rrggbb)から、予定の色を作る。
 * 薄い色は、透明度ではなく、白との混色(color-mix)で作る。透明にすると、後ろの時間の罫線や
 * 重なった部分が透けて違和感がある(SPEC §6.5)。混色の結果は不透明。
 */
export const DEFAULT_CALENDAR_COLOR = "#039be5";
/** 自分のメインのカレンダーの予定は、ZENK レッド(ブランド色 #D42A1C)で出す(ユーザー要望 2026-10-07)。 */
export const BRAND_CALENDAR_COLOR = "#d42a1c";

const HEX = /^#[0-9a-fA-F]{6}$/;
export const safeColor = (color: string | undefined): string =>
  color && HEX.test(color) ? color : DEFAULT_CALENDAR_COLOR;

/** 色と白を、色が pct % の割合で混ぜる。 */
export const tint = (color: string, pct: number): string =>
  `color-mix(in srgb, ${safeColor(color)} ${pct}%, white)`;

/** その色の上に置く文字色(白か、ほぼ黒)。明るさ(相対輝度)で選ぶ。 */
export function readableOn(color: string): "#ffffff" | "#1f2937" {
  const c = safeColor(color).slice(1);
  const [r, g, b] = [0, 2, 4].map((i) => {
    const v = Number.parseInt(c.slice(i, i + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.45 ? "#1f2937" : "#ffffff";
}

/** 予定・凡例の色。自分のメインのカレンダーは ZENK レッド、共有されたカレンダーは Google 側の色。 */
export const calendarColor = (
  calendar: { color: string; primary?: boolean | undefined } | undefined,
): string => (calendar?.primary ? BRAND_CALENDAR_COLOR : safeColor(calendar?.color));
